@if (!hasPermission) {
  <div class="flex items-center justify-center gap-2 rounded-lg border border-red-200 bg-red-50 p-6 text-sm font-semibold text-red-700">
    <mat-icon class="!text-base text-red-400">lock</mat-icon>
    Permissions Restricted
  </div>
} @else {
  <div>
    <div class="mb-3 flex items-center justify-between">
      <h3 class="text-secondary flex items-center gap-1 text-sm font-semibold uppercase tracking-wide">
        <mat-icon class="text-base text-orange-500">event_busy</mat-icon>
        {{ title }}
      </h3>
      @if (!loading && total > 0) {
        <span class="rounded-full px-2 py-0.5 text-[10px] font-bold" [ngClass]="total | countBadge">{{ total }}</span>
      }
    </div>

    @if (loading) {
      <div class="flex justify-center py-4"><mat-spinner diameter="28" color="primary" /></div>
    }

    @if (error && !loading) {
      <div class="text-secondary flex items-center gap-2 py-3 text-sm">
        <mat-icon class="text-base text-gray-400">error_outline</mat-icon>
        {{ error }}
      </div>
    }

    @if (!error && !loading && workOrders.length === 0) {
      <div class="flex flex-col items-center gap-1.5 rounded-lg border border-dashed border-gray-200 py-8 text-center">
        <mat-icon class="!text-3xl text-gray-300">event_available</mat-icon>
        <span class="text-xs text-gray-400">No work orders expiring within 90 days</span>
      </div>
    }

    @if (!error && !loading && workOrders.length > 0) {
      <div class="divide-y divide-gray-50">
        @for (c of workOrders.slice(0, 5); track c.id) {
          @let days = getDaysLeft(c.end_date);
          <a [routerLink]="['/procurement/work-orders/detail', c.id]" class="flex items-center gap-2.5 py-2.5 transition-colors hover:bg-gray-50">
            <!-- Icon badge — color by urgency -->
            <div class="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg" [class.bg-red-50]="days <= 7" [class.bg-orange-50]="days > 7 && days <= 30" [class.bg-yellow-50]="days > 30">
              <mat-icon class="!text-sm" [class.text-red-500]="days <= 7" [class.text-orange-500]="days > 7 && days <= 30" [class.text-yellow-600]="days > 30">event_busy</mat-icon>
            </div>
            <!-- Content -->
            <div class="min-w-0 flex-1">
              <div class="truncate text-xs font-semibold text-gray-800">{{ c.title }}</div>
              <div class="text-[10px] text-gray-400">
                @if (c.reference) {
                  <span class="font-medium text-gray-500">{{ c.reference }}</span> ·
                }
                Expires {{ c.end_date }}
              </div>
            </div>
            <!-- Days left pill -->
            <span
              class="shrink-0 rounded-full px-2 py-0.5 text-[10px] font-bold leading-none"
              [class.bg-red-100]="days <= 7"
              [class.text-red-700]="days <= 7"
              [class.bg-orange-100]="days > 7 && days <= 30"
              [class.text-orange-700]="days > 7 && days <= 30"
              [class.bg-yellow-100]="days > 30"
              [class.text-yellow-700]="days > 30"
            >
              {{ days }} d left
            </span>
          </a>
        }
      </div>
    }
  </div>
}
